import { Shared } from "utility/shared";

export class TableFilterModel {
	userId: number | null;
	sortBy: string;
	sortType: string;
	pageNo: number;
	pageSize: number;
	filterField: string;
	filterField_1: string;
	filterField_2: string;
	filterField_3: string;
	filterField_4: string;
	filterField_5: string;
	filterField_6: string;
	filterField_7: string;
	filterField_8: string;
	filterField_9: string;
	filterField_10: string;
	filterField_11: string;
	filterField_12: string;
	filterField_13: string;
	filterField_14: string;
	filterField_15: string;
	filterField_16: string;
	filterField_17: string;
	filterField_18: string;
	filterField_19: string;
	filterField_20: string;
	filterField_21: string;
	filterField_22: string;
	fromDate: Date | null;
	toDate: Date | null;
	columnList: string[]; // pass selected columns to display in excel file
	columnKeyList: Record<string, string> | null; // pass selected columns as key value pair to display in excel file

	constructor() {
		this.userId = null;
		this.sortBy = "";
		this.sortType = "";
		this.pageNo = 1;
		this.pageSize = Shared.defaultPageSize;
		this.filterField = "";
		this.filterField_1 = "";
		this.filterField_2 = "";
		this.filterField_3 = "";
		this.filterField_4 = "";
		this.filterField_5 = "";
		this.filterField_6 = "";
		this.filterField_7 = "";
		this.filterField_8 = "";
		this.filterField_9 = "";
		this.filterField_10 = "";
		this.filterField_11 = "";
		this.filterField_12 = "";
		this.filterField_13 = "";
		this.filterField_14 = "";
		this.filterField_15 = "";
		this.filterField_16 = "";
		this.filterField_17 = "";
		this.filterField_18 = "";
		this.filterField_19 = "";
		this.filterField_20 = "";
		this.filterField_21 = "";
		this.filterField_22 = "";
		this.fromDate = null;
		this.toDate = null;
		this.columnList = [];
		this.columnKeyList = null;
	}
}
